import { FC } from 'react';
import cx from 'classnames';

import { ImageWithCaption } from 'lib/sanity/types';

export interface Props {
  title?: String | null;
  description?: String | null;
  singleColumn?: Boolean;
  isCaseStudy?: Boolean;
  className?: String;
}
const ImageCaption: FC<Props> = ({
  title,
  description,
  singleColumn,
  isCaseStudy,
  className,
}) => {
  return (
    <>
      {(title || description) && (
        <div
          className={cx(
            'flex flex-col space-y-1 text-small desktop:text-desktop-small',
            className,
            {
              'CaseStudy__inner-wrapper': isCaseStudy && singleColumn,
              'px-0': isCaseStudy || !singleColumn,
            },
          )}
        >
          {title && (
            <div>
              <span className="mr-1.5">↑</span>
              <span>{title}</span>
            </div>
          )}
          {description && (
            <>
              <p className="text-black/60">{description}</p>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default ImageCaption;
